// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__37e9c","boxTitle":"Qualiphy_boxTitle__1X_RY","box":"Qualiphy_box__3NLfE","toggleWrap":"Qualiphy_toggleWrap__3pGxc"};